export const delayDecorator = (fn: () => void) => {
  setTimeout(fn, 50); // This is a huge hack, but we have to live with it because a lot of existing merchants already depend on it. (lululemon)
};
